export default "__VITE_ASSET__CAzN8n1G__";